/** Site menü *********************/

/**
 * Handles the site menu toggle functionality.
 * Toggles the menu-opened class and calls the conferenceTitleDisplay function.
 * Also removes the menu-opened class when the page overlay is clicked.
 */
window.siteMenuHandler = function () {
	const conferenceTitleDisplay = () =>
		window.displayEventTitle(document.body.classList.contains("menu-opened"));

	document.querySelectorAll(".menu-handler").forEach((item) => {
		item.addEventListener("click", (event) => {
			event.preventDefault();
			document.body.classList.toggle("menu-opened");
			conferenceTitleDisplay();
		});
	});
	document
		.querySelector(".page-overlay")
		.addEventListener("click", function (t) {
			if (t.target.className === "page-overlay") {
				document.body.classList.remove("menu-opened");
				conferenceTitleDisplay();
			}
		});
	makeCurrentActive();
};
/**
 * Makes the current menu item active.
 * Iterates through the mainmenu items and adds the active class to the item that matches the current URL.
 */
window.makeCurrentActive = function () {
	const list = document.querySelectorAll(".mainmenu ul li a");
	const current = document.location.href;
	list.forEach((item) => {
		if (item.href === current) {
			item.classList.add("active");
		}
	});
};
/**
 * Displays the event title on the main image content section.
 * If isOpen is true, it clones the .mainmenu-wrapper template and injects it after the .mainmenu-wrapper element.
 * It replaces the h2 text with the conference title and the span innerHTML with the buttons innerHTML.
 * If isOpen is false, it removes the injected element.
 */
window.displayEventTitle = function (isOpen) {
	const mainImageContent = document.querySelector(".main-image-content");
	if (!mainImageContent) {
		return;
	}
	const temp = document.querySelector(".mainmenu-wrapper template");
	if (isOpen) {
		if (!temp) {
			return;
		}
		const confH1 = mainImageContent.querySelector("h1");
		if (!confH1) {
			return;
		}
		const title = confH1.textContent;
		const button = document.querySelector(".main-image-content-menu .buttons").innerHTML.replace(/site-btn/, "site-btn wide");
		let injected = temp.content.cloneNode(true);
		injected.querySelector("h2").textContent = title;
		injected.querySelector("span").innerHTML = button;
		temp.after(injected);
	} else {
		if (temp) {
			temp.remove();
		}
	}
};
/**
 * Listens for the Escape key press event.
 * If the document body classList does not contain 'menu-opened', it returns.
 * If the document body classList contains 'menu-opened', it removes the 'menu-opened' classList item.
 */
document.onkeyup = (event) => {
	if (event.key === "Escape") {
		if (!document.body.classList.contains("menu-opened")) {
			return;
		}
		document.body.classList.remove("menu-opened");
	}
};
/** Homepage amimate ******************** */

/**
 * Animates the event cards on the homepage.
 * Adds an event listener to each event card.
 * When the card is hovered over, it adds the 'animate' class to the card.
 * After 300ms, it sets the display of the lead text and button to block,
 * and the padding of the lead text to 80px if the card has badges.
 * When the card is hovered out, it removes the 'animate' class,
 * sets the display of the lead text and button to none,
 * and sets the padding of the lead text to the default.
 * @return {void}
 */
const cardAnimation = () => {
	const cards = document.querySelectorAll(".cnf-block");
	if (cards.length == 0 || window.innerWidth < 769) {
		return;
	}
	cards.forEach((card) => {
		card.addEventListener("mouseenter", () => {
			var content = card.querySelector("div:last-child");
			const style = window.getComputedStyle(content);
			if (style.position == "static") {
				return;
			}
			if (content.previousElementSibling.querySelector(".cnf-block-badges")) {
				card.classList.add("animate-badges");
			} else {
				card.classList.add("animate");
			}
			setTimeout(() => {
				if (
					card.classList.contains("animate") ||
					card.classList.contains("animate-badges")
				) {
					card.querySelector(".cnf-block-lead").style.display = "-webkit-box";
					card.querySelector(".button-wrapper").style.display = "block";
				}
			}, 300);
		});
		card.addEventListener("mouseleave", () => {
			var content = card.querySelector("div:last-child");
			const style = window.getComputedStyle(content);
			if (style.position == "static") {
				return;
			}
			card.querySelector(".cnf-block-lead").style.display = "none";
			card.querySelector(".button-wrapper").style.display = "none";
			card.classList.remove("animate");
			card.classList.remove("animate-badges");
			content.style.paddingTop = "var(--card-padding)";
		});
	});
};
/** END Homepage amimate ********************/

/** Program oldal ******************** */
/**
 * Sets the width of parallel columns in a specified section.
 *
 * This function selects all elements with the class 'parallel-column' and a
 * data attribute 'data-group' matching the given section. It sets their width
 * based on the specified column count. If the column count is 2 or 3, it
 * calculates the width as a percentage (100 divided by column count) and applies
 * it to each element. For any other column count, the function exits without
 * making changes.
 *
 * @param {string} section - The section identifier used to select parallel columns.
 * @param {number} columnCount - The number of columns for which the width is to be set.
 * @return {void}
 */
window.setParallelColumnWidths = (section, columnCount) => {
	const parallelColumns = document.querySelectorAll(`.parallel-column[data-group="${section}"]`);
	let width;
	switch (columnCount) {
		case 2:
		case 3:
			width = 100 / columnCount + "%";
			break;
		default:
			return;
	}
	parallelColumns.forEach((element) => {
		element.style.width = width;
	});
};

/**
 * Sets the heights of the parallel columns in a program section.
 * @param {string} section - The name of the program section.
 * @param {number} colcount - The number of columns in the section.
 * @return {void}
 */
window.setHeights = (section, colcount) => {
	/*const hourColumns = document.querySelectorAll('div[data-hourcolumn]');
	  hourColumns.forEach(item => {
		  let content = item.querySelectorAll('div[data-hour]').length;
		  if (content == 0) {
			  item.remove();
		  }
	  });*/
	setParallelColumnWidths(section, colcount);
	const sections = document.querySelectorAll('[data-section="' + section + '"]');
	let maxheight = 0;
	sections.forEach((element) => {
		if (element.clientHeight > maxheight) {
			maxheight = element.clientHeight;
		}
	});
	sections.forEach((element, i) => {
		element.style.height = maxheight + "px";
		if (i == 0) {
			element.setAttribute("data-eventtime", element.dataset.hour);
			element.removeAttribute("data-hour");
		}
	});

	// az orak elvalasztasa a parallel column-okban
	maxheight = 0;
	const parallel = document.querySelectorAll(`.parallel-column[data-keys][data-group=${section}]`);
	parallel.forEach((element, i) => {
		const hours = element.dataset.keys;
		let array = JSON.parse(hours);
		for (let i = 0; i < array.length; i++) {
			if (array[i] < 10) {
				array[i] = "0" + array[i];
			}
			const hourCols = document.querySelectorAll(`[data-hourcolumn="${array[i]}-${section}"]`);
			maxheight = 0;
			hourCols.forEach((element, z) => {
				if (element.clientHeight > maxheight) {
					maxheight = element.clientHeight;
				}
				if (z == 0) {
					element.setAttribute("data-eventtime", array[i] + ":00");
				}
			});
			hourCols.forEach((element) => {
				element.style.height = maxheight + "px";
			});
		}
	});
};

/**
 * Scrolls a program section horizontally.
 * @param {string} item - The ID of the program section to scroll.
 * @param {number} direction - The direction to scroll. 1 to scroll right, -1 to scroll left.
 * @return {void}
 */
window.scrollPanel = (item, direction) => {
	const slider = document.querySelector(`div[data-slider="${item}"]`).parentElement;
	const col = slider.querySelectorAll(".parallel-column")[0].clientWidth;
	if (direction == 1) {
		slider.scrollLeft += col + 10;
	} else {
		slider.scrollLeft -= col + 10;
	}
};

/**
 * Hides all days except the first one and sets up event listeners on the day selector tabs.
 * When a tab is clicked, it hides all days except the one that matches the tab's data-loop attribute.
 * Then it scrolls to the top of the page and calls placeTimeBadges.
 * @return {void}
 */
const daySelector = () => {
	const onCorrectPage = document.querySelector(".time-line-container");
	if (onCorrectPage == null) {
		return;
	}
	/* az osszes nap elrejtese, kiveve az elsot */
	const allDays = document.querySelectorAll("div[data-day]");
	if (allDays.length < 2) {
		return;
	}
	const tabs = document.querySelectorAll("[data-select]");
	const currentDay = document.querySelector("span[data-currentpage]");
	const rawDefaultDay = currentDay?.dataset.defaultday ?? "0";
	let defaultDay = Number.parseInt(rawDefaultDay, 10);
	if (Number.isNaN(defaultDay) || defaultDay < 0 || defaultDay >= allDays.length) {
		defaultDay = 0;
	}
	currentDay.dataset.currentpage = String(defaultDay);

	allDays.forEach((day) => {
		day.style.display = "block";
		if (day.dataset.count !== String(defaultDay)) {
			day.style.display = "none";
		}
	});

	const pagerWrapper = document.querySelector('[data-id="program-pager"]');
	const previousBtn = pagerWrapper.querySelector("div:first-child");
	const nextBtn = pagerWrapper.querySelector("div:last-child");
	function handleButton(btn, visibility) {
		btn.classList.remove("hidden", "visible");
		btn.classList.add(visibility);
	}
	handleButton(previousBtn, defaultDay === 0 ? "hidden" : "visible");
	handleButton(nextBtn, defaultDay >= tabs.length - 1 ? "hidden" : "visible");

	tabs.forEach((tab) => {
		tab.onclick = () => {
			tabs.forEach((tabz) => {
				tabz.classList.remove("weight-700", "lrborders", "me-2");
			});
			tab.classList.add("weight-700", "lrborders", "me-2");
			currentDay.dataset.currentpage = tab.dataset.loop;
			switch (true) {
				case tab.dataset.loop == "0":
					handleButton(previousBtn, "hidden");
					handleButton(nextBtn, "visible");
					break;
				case tab.dataset.loop == tabs.length - 1:
					handleButton(previousBtn, "visible");
					handleButton(nextBtn, "hidden");
					break;
				default:
					handleButton(previousBtn, "visible");
					handleButton(nextBtn, "visible");
					break;
			}
			allDays.forEach((day) => {
				day.style.display = day.dataset.count !== tab.dataset.loop ? "none" : "block";
			});

			const toScroll = getAbsolutePosition(document.querySelector(".time-line-container")).top - (123 + 85);
			window.scrollTo(0, toScroll);
			window.placeTimeBadges();
		};
	});
};

window.getAbsolutePosition = (element) => {
	const rect = element.getBoundingClientRect();

	return {
		top: rect.top + window.scrollY, // Add vertical scroll
		left: rect.left + window.scrollX, // Add horizontal scroll
		bottom: rect.bottom + window.scrollY,
		right: rect.right + window.scrollX,
	};
};

/**
 * Changes the displayed day in the program section.
 * @param {number} direction - The direction to change the day. 1 to go to the next day, -1 to go to the previous day.
 * @return {void}
 */
window.pager = (direction) => {
	let currentDay = document.querySelector("span[data-currentpage]");
	let nextDayIndex = parseInt(currentDay.dataset.currentpage) + direction;
	let maxDays = document.querySelectorAll("div[data-day]").length;
	if (nextDayIndex >= maxDays || nextDayIndex < 0) {
		return;
	}
	currentDay.dataset.currentpage = nextDayIndex;
	const allDays = document.querySelectorAll("div[data-day]");
	const previousBtn = document.querySelector(".program-pager div:first-child");
	const nextBtn = document.querySelector(".program-pager div:last-child");

	function handleButton(btn, visibility) {
		btn.classList.remove("hidden", "visible");
		btn.classList.add(visibility);
	}

	let dateTab;
	allDays.forEach((day, index) => {
		day.style.display = index === nextDayIndex ? "block" : "none";
		dateTab = document.querySelector('div[data-select="' + day.dataset.day + '"]');
		if (index == nextDayIndex) {
			dateTab.classList.add("weight-700", "lrborders", "me-2");
		} else {
			dateTab.classList.remove("weight-700", "lrborders", "me-2");
		}
	});

	handleButton(previousBtn, nextDayIndex == 0 ? "hidden" : "visible");
	handleButton(nextBtn, nextDayIndex == maxDays - 1 ? "hidden" : "visible");

	const toScroll = getAbsolutePosition(document.querySelector(".time-line-container")).top - (123 + 85);
	window.scrollTo(0, toScroll);
	window.placeTimeBadges();
};

/**
 * Adjusts the height of time elements to match the cumulative height of their associated events
 * and makes them visible within the timeline container. It processes each day and time to ensure
 * the visual alignment of time badges with their corresponding events.
 *
 * The function first checks if it is on the correct page by ensuring the existence of a timeline
 * container. It then iterates over each time wrapper and retrieves the times for each day. For each
 * time, it calculates the total height of all events occurring at that time and sets the height of
 * the time element accordingly. Finally, it makes the time element visible.
 */
window.placeTimeBadges = () => {
	const onCorrectPage = document.querySelectorAll(".time-line-container").length;
	if (parseInt(onCorrectPage) == 0) {
		return;
	}
	const subHeaderPosition = document.querySelector(`.program-subheader`).getBoundingClientRect();
	const headerPosition = document.querySelector("header").getBoundingClientRect();
	const headerHeight = subHeaderPosition.height + headerPosition.height;

	const extraHeight = 750;
	const timeWrappers = document.querySelectorAll(`.times[data-daytimes]`);
	let day,
		time,
		height = -1;
	let lastElements = [];
	timeWrappers.forEach((dayElement) => {
		day = dayElement.dataset.daytimes;
		const absolute = dayElement.querySelector(".absolute-wrapper");
		const eventsHolder = document.querySelector(`[data-day="${day}"] .events`);
		absolute.style.height = eventsHolder.offsetHeight + extraHeight + "px";
		const times = dayElement.querySelectorAll(".time[data-time]");
		lastElements.push(times[times.length - 1]);
		times.forEach((timeElement, i) => {
			if (i < times.length - 1) {
				time = timeElement.dataset.time;
				const events = document.querySelectorAll(`[data-day="${day}"] [data-eventtime="${time}"]`);
				height = 0;
				events.forEach((event) => {
					height += event.clientHeight;
				});
				timeElement.style.height = `${height}px`;
				timeElement.style.top = `${headerHeight - 5}px`;
			}
			timeElement.classList.add("visible");
		});
	});

	/*function handleScrollEvent(lastTop, day, time, headerHeight, eventsHolder, extraHeight, absolute) {
		console.log(eventsHolder);
		if (!eventsHolder || !absolute) {
			return;
		}
		let badge = document.querySelector(`.time[data-timeday="${day}"][data-time="${time}"]`);
		lastTop = badge.getBoundingClientRect().top;
		if (lastTop <= headerHeight) {
			absolute.style.height = eventsHolder.offsetHeight - 30 + "px";
		} else {
			absolute.style.height = eventsHolder.offsetHeight + extraHeight + "px";
		}
	}*/

	var lastTop = 0;
	lastElements.forEach((element) => {
		let day = element.dataset.timeday;
		let time = element.dataset.time;
		const eventsHolder = document.querySelector(`[data-day="${day}"] .events`);
		const absolute = document.querySelector(`.absolute-wrapper[data-timeday="${day}"]`);
		if (!eventsHolder || !absolute) {
			return;
		}
    	// Névvel ellátott függvény referencia
		const scrollHandler = () => {
			let badge = document.querySelector(`.time[data-timeday="${day}"][data-time="${time}"]`);
			let lastTop = badge.getBoundingClientRect().top;
			if (lastTop <= headerHeight) {
				absolute.style.height = eventsHolder.offsetHeight - 30 + "px";
			} else {
				absolute.style.height = eventsHolder.offsetHeight + extraHeight + "px";
			}
		};
		window.removeEventListener("scroll", scrollHandler);
    	window.addEventListener("scroll", scrollHandler);
	});
};

/**
 * Toggles the display mode of a program view between linear and parallel.
 *
 * This function modifies the visibility and layout of time columns and event
 * modes based on the specified view mode. In 'L' (linear) mode, it hides
 * the time columns and parallel modes, displaying only the linear modes. In
 * 'P' (parallel) mode, it displays the time columns and parallel modes,
 * hiding the linear modes. Additionally, it updates the active state of the
 * view mode buttons.
 *
 * @param {string} mode - The view mode to activate. 'L' for linear view, 'P' for parallel view.
 * @return {void}
 */
window.viewMode = (mode) => {
	const timeCols = document.querySelectorAll(".program-wrapper > .times");
	const multiModes = document.querySelectorAll('span[data-multimode="parallel"]');
	const linearModes = document.querySelectorAll('span[data-multimode="linear"]');

	function hideDescr(mode) {
		document
			.querySelectorAll(".program-wrapper .event-description")
			.forEach((desc) => {
				desc.hidden = mode;
			});
	}
	setActiveStatus(mode);
	if (mode == "L") {
		hideDescr(false);
		timeCols.forEach((timeCol) => {
			timeCol.style.display = "none";
		});
		multiModes.forEach((multiMode) => {
			multiMode.style.display = "none";
		});
		linearModes.forEach((linearMode) => {
			linearMode.style.display = "block";
			linearMode.style.width = "100%";
		});
	}
	if (mode == "P") {
		hideDescr(true);
		timeCols.forEach((timeCol) => {
			timeCol.style.display = "block";
		});
		multiModes.forEach((multiMode) => {
			multiMode.style.display = "block";
		});
		linearModes.forEach((linearMode) => {
			linearMode.style.display = "none";
		});
	}
	const viewModes = document.querySelectorAll(".view-mode");
	viewModes.forEach((viewMode) => {
		viewMode.classList.remove("active");
	});
	if (document.getElementById(mode)) {
		document.getElementById(mode).classList.add("active");
	}
};

window.setActiveStatus = (mode) => {
	document.getElementById("current-viewmode").innerText = mode;
};
window.getActiveStatus = () => {
	return document.getElementById("current-viewmode").innerText;
};

window.resetViewMode = () => {
	if (!document.location.href.match(/\/\d+\/program/)) {
		return;
	}
	const viewModeSwitcher = document.querySelectorAll(".view-mode");
	if (viewModeSwitcher.length > 0) {
		// viewModeSwitcher.forEach(viewMode => viewMode.classList.remove('d-none'));
		viewModeSwitcher.forEach((viewMode) => (viewMode.hidden = false));
	}

	const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	if (viewportWidth < 769) {
		// md
		setActiveStatus("L");
		window.viewMode("L");
	}
	if (viewportWidth < 576) {
		// sm
		if (viewModeSwitcher.length > 0) {
			//viewModeSwitcher.forEach(viewMode => viewMode.classList.add('d-none'));
			viewModeSwitcher.forEach((viewMode) => (viewMode.hidden = true));
		}
	}
};
/** END Program oldal ******************** */

/**
 * Toggles the visibility of the mobile conference menu.
 *
 * This function is called when the user clicks on the mobile conference menu button.
 * It toggles the "show" class on the specified mobile conference menu content element.
 *
 * @param {string} mode - The mode of the mobile conference menu to open. The element's class name should be ".links-mobile-content.${mode}".
 * @return {void)
 */
window.openMobileConferenceMenu = (mode) => {
	let dropDown;
	let elementName = `.links-mobile-content.${mode}`;
	dropDown = document.querySelector(elementName);
	dropDown.classList.toggle("show");
};

/**
 * Closes all mobile conference menus.
 * This function is called when the user clicks outside of the mobile conference menu.
 * @param {Event} event - The click event.
 * @return {void}
 */
window.closeMobileConferenceMenu = (event) => {
	if (!event.target.matches(".links-mobile-btn")) {
		var linksMobile = document.getElementsByClassName("links-mobile-content");
		var i;
		for (i = 0; i < linksMobile.length; i++) {
			var openMenu = linksMobile[i];
			if (openMenu.classList.contains("show")) {
				openMenu.classList.remove("show");
			}
		}
	}
};

/**
 * Updates the text of the mobile program menu button to match the currently active link
 *
 * This function is called after the page has finished loading and is used to update the text
 * of the mobile program menu button to match the currently active link.
 */
const setMobileProgramMenuText = () => {
	const mobileLinks = document.querySelectorAll(".links-mobile-content li a");
	const svgIcon = '<svg class="links-mobile-btn-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
	mobileLinks.forEach((element) => {
		if (element.classList.contains("active")) {
			element.parentElement.parentElement.previousElementSibling.innerHTML = element.innerHTML + svgIcon;
		}
	});
};

/** Arak oldal ******************** */
/**
 * Toggles the currency display mode on the page.
 *
 * This function switches the visible currency mode for elements with the 'currency' class
 * to the specified currency. It hides all currency modes initially and then displays the
 * selected one with a scale animation. It also updates the active state of currency buttons
 * to reflect the current selection.
 *
 * @param {string} currency - The currency mode to activate. It should match the data-mode
 * attribute of the elements to be displayed.
 * @return {void}
 */
window.changeCurrency = (currency) => {
	const rows = document.querySelectorAll(".currency");
	let currencyMode;
	rows.forEach((item) => {
		currencyMode = item.querySelector(`[data-mode="${currency}"]`);
		if (currencyMode.style.display !== "none") {
			return;
		}
		item.querySelectorAll("[data-mode]").forEach((item) => (item.style.display = "none"));
		currencyMode.style.display = "inline-block";
		currencyMode.style.transform = "scale(.1)";
		setTimeout(() => {
			item.querySelector(`[data-mode="${currency}"]`).style.transform = "scale(1)";
		}, 100);
	});
	document.querySelectorAll(`[data-currency]`).forEach((item) => item.classList.remove("active"));
	document.querySelector(`[data-currency="${currency}"]`).classList.add("active");
};
/** END Arak oldal ******************** */

/** CountDown ******************** */
/**
 * Updates provided fields with the countdown to a specified date.
 *
 * This function calculates the time remaining until the specified countdown date
 * and updates the innerHTML of the provided fields with the remaining days, hours,
 * minutes, and seconds. If the countdown is complete, it clears the interval and
 * sets all fields to '0'.
 *
 * @param {number} countDownDate - The target date for the countdown in milliseconds.
 * @param {Array} fields - An array of elements to update with the countdown values.
 * @param {number} random - The interval ID to clear when the countdown is complete.
 * @return {void}
 */
window.countDown = (countDownDate, fields, random) => {
	const now = new Date().getTime();
	const distance = countDownDate - now;
	const time = [];
	time.push(Math.floor(distance / (1000 * 60 * 60 * 24)));
	time.push(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
	time.push(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
	time.push(Math.floor((distance % (1000 * 60)) / 1000));

	var c = 0;
	fields.forEach((field) => {
		field.innerHTML = time[c];
		c++;
	});
	if (distance < 0) {
		clearInterval(random);
		fields.forEach((field) => {
			field.innerHTML = "0";
			c++;
		});
	}
};
/** END CountDown ******************** */

/** Eloadok oldal ******************** */
/**
 * Updates the height of all speaker cards to be equal to the tallest one.
 * This function iterates through all speaker cards, removes inline styles,
 * and sets their height to the maximum height found.
 */
window.resizeSpeakerCards = () => {
	const onCorrectPage = document.querySelectorAll(".speakers-container").length;
	if (parseInt(onCorrectPage) == 0) {
		return;
	}
	const speakerCards = document.querySelectorAll(".speakers-container .speaker-card");
	let maxheight = 0;
	speakerCards.forEach((card) => {
		card.removeAttribute("style");
		if (card.clientHeight > maxheight) {
			maxheight = card.clientHeight;
		}
	});
	speakerCards.forEach((card) => {
		card.style.height = maxheight + "px";
	});
};
/** END Eloadok oldal ******************** */

/** Informaciok oldal ******************** */
/**
 * Animates the FAQ section by toggling the visibility of the answers.
 * On click the function toggles the 'active' class on the question element and its corresponding answer element.
 * If the question element already has the 'active' class when clicked, the function removes the 'active'
 * class and sets the maxHeight of the answer element to 0.
 * If the question element does not have the 'active' class when clicked, the function adds the 'active'
 * class and sets the maxHeight of the answer element to its scrollHeight.
 */
window.dropDownAnimate = (element) => {
	let question = document.querySelectorAll(`${element} [data-q]`);
	question.forEach((question) => {
		question.addEventListener("click", (event) => {
			const active = document.querySelector(`${element} [data-q].active`);
			if (active && active !== question) {
				active.classList.toggle("active");
				active.nextElementSibling.style.maxHeight = 0;
			}
			question.classList.toggle("active");
			try {
				question.querySelector(`.dropdown-qa svg[data-icon="chevron"]`).classList.toggle("rotate-90");
			} catch (error) { }

			const answer = question.nextElementSibling;
			if (question.classList.contains("active")) {
				answer.style.maxHeight = answer.scrollHeight + "px";
			} else {
				answer.style.maxHeight = 0;
			}
		});
	});
};
/** END Informaciok oldal ******************** */

/** sticky foot info ******************** */
/**
 * Manages the sticky foot info section.
 *
 * Listens for a click event on the close button and sets a cookie to hide the sticky foot info
 * section. Checks for the existence of the cookie on page load and removes the element if it exists.
 * If the cookie does not exist, it displays the sticky foot info section after 700ms.
 */
window.stickyFootInfo = () => {
	const closeButton = document.getElementById("sticky-foot-close");
	if (!closeButton) {
		return;
	}
	closeButton.addEventListener("click", () => {
		document.querySelector(".sticky-foot").style.display = "none";
		document.cookie = "sticky-foot=hidden;path=/;max-age=" + 60 * 60;
	});
	document.addEventListener("DOMContentLoaded", () => {
		if (document.cookie.split(";").some((item) => item.trim().startsWith("sticky-foot=hidden"))) {
			document.querySelector(".sticky-foot").remove();
		} else {
			setTimeout(() => {
				document.querySelector(".sticky-foot").style.display = "flex";
			}, 700);
		}
	});
};
/** END sticky foot info ******************** */

/** END Értesités kérése dialog ******************** */

/**
 * Displays statistical numbers with a gradual increase effect.
 *
 * Selects all elements with the class name 'numbers', and for each element,
 * it increments the text content in a gradual manner, giving the impression of a
 * counter increasing.
 *
 * The increment is calculated by dividing the number by the total number of steps
 * in the animation. The animation is triggered by a setInterval function, which is
 * cleared when the animation is finished.
 */

window.displayStatNumbers = function () {
	const els = document.querySelectorAll(".numbers");
	if (els.length === 0) {
		return;
	}
	const formatNumber = (number) => new Intl.NumberFormat("hu-HU").format(number);

	const currentTime = Math.floor(Date.now() / 1000);
	const savedTime = localStorage.getItem("statnumbers") || null;
	if (savedTime !== null && currentTime - savedTime < 1800) {
		// 30 perc
		els.forEach((el) => {
			let number = parseInt(el.dataset.value.replace(/\s/g, ""));
			el.textContent = formatNumber(number);
		});
		return;
	}
	const duration = 1200;
	const intervalTime = 20;
	let steps = Math.ceil(duration / intervalTime);
	els.forEach((el) => {
		let number = parseInt(el.dataset.value.replace(/\s/g, ""));
		let num = 0;
		let jump = Math.ceil(number / steps);
		let interval = setInterval(() => {
			if (num < number) {
				if (num + jump >= number) {
					num = number;
					el.textContent = formatNumber(num);
					clearInterval(interval);
				} else {
					el.textContent = formatNumber(num);
					num = num + jump;
				}
			}
		}, intervalTime);
	});
	localStorage.setItem("statnumbers", currentTime);
};

/**
 * Adds the 'shadow' class to the header element when the window scroll position exceeds 0.
 * This is a utility function for styling the header element when the user is scrolling down the page.
 */
window.setHeaderShadow = function () {
	const header = document.querySelector("header");
	if (window.scrollY > 0) {
		header.classList.add("shadow");
	} else {
		header.classList.remove("shadow");
	}
};
/**
 * Hides the secondary menu when the window scroll position exceeds 85.
 * This is a utility function for styling the secondary menu element when the user is scrolling down the page.
 */
window.setSecondaryMenuVisibility = function () {
	let confMenu = document.querySelector(".main-image-content-menu");
	if (!confMenu) {
		return;
	}
	window.addEventListener("scroll", function () {
		if (window.scrollY > 85) {
			confMenu.style.visibility = "hidden";
			document.querySelector(".main-image-content-menu-sticky").classList.remove("d-none");
		} else {
			confMenu.style.visibility = "visible";
			document.querySelector(".main-image-content-menu-sticky").classList.add("d-none");
		}
	});

};

/**
 * Repairs the YouTube images by replacing the low-resolution image with a high-resolution one
 * when the image is loaded and its natural width is less than 200 pixels.
 * @param {string} elements - The CSS selector string that selects the YouTube images to be repaired.
 */
window.repairYoutubeImages = function (elements) {
	document.querySelectorAll(elements).forEach((img) => {
		img.onload = () => {
			if (img.naturalWidth < 200) {
				img.src = img.src.replace("maxresdefault", "hqdefault");
			}
		};
	});
};

/**
 * Makes all frontpage conf cards with the class 'cnf-block-content' clickable
 * by adding an event listener to each element. When an element is clicked, the
 * browser will navigate to the URL specified in the element's 'data-href'
 * attribute.
 */
window.clickableCards = function () {
	const confCards = document.querySelectorAll(".cnf-block-content");
	if (confCards.length === 0) {
		return;
	}
	confCards.forEach((block) => {
		block.addEventListener("click", () => {
			const url = block.getAttribute("data-href");
			if (url) {
				window.location.href = url;
			}
		});
	});
};

window.logoScrollEffect = function () {
	const groups = document.querySelectorAll(".logo-slider .logo-slider-track");
	if (groups.length === 0 || groups.item(0).offsetWidth == 0) {
		groups.item(0).parentNode.parentNode.remove();
		return;
	}
	const carouselWidth = document.querySelector(".logo-slider").offsetWidth;
	const cloneCount = Math.ceil(carouselWidth / groups.item(0).offsetWidth);
	groups.forEach((group) => {
		for (let i = 0; i < cloneCount; i++) {
			const clone = group.cloneNode(true);
			group.parentNode.appendChild(clone);
		}
	});
};
window.handleSearchClear = function () {
	const form = document.getElementById("menu-search");
	if (!form) {
		return;
	}
	form.addEventListener("submit", function () {
		setTimeout(() => {
			document.getElementById("menu-search-input").value = "";
		}, 100);
	});
};

window.handleLoginDropdown = function () {
	const panel = document.getElementById("login-dropdown");
	if (!panel) {
		return;
	}
	panel.addEventListener("click", function (e) {
		if (["A", "BUTTON", "INPUT"].includes(e.target.tagName)) return;
		e.stopPropagation();
	});
};

window.createInfoMap = function (locationData, basedataId) {
	let fullAddress = locationData.location_address.replace(/ krt.? /i, " körút ");
	let hotelCoords = locationData.hotel_coords || "";
	let hotelCoordsArray = hotelCoords.length ? hotelCoords.split(",") : [];
	let initialZoom = 17;
	const popupContent = `<div class="text-center">${locationData.location}<br>${locationData.location_address}</div>`;

	//$.ajaxSetup({
	//	headers: {
	//		'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
	//	}
	//});

	function initialize(lat, long, name, zoom, div) {
		var mymap = L.map(div, {
			scrollWheelZoom: false,
		}).setView([lat, long], zoom);

		L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
			maxZoom: 19,
			id: "mapbox/streets-v11",
			attribution: `Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>,
				Imagery © <a href="https://www.mapbox.com/">Mapbox</a>`,
		}).addTo(mymap);

		L.marker([lat, long], {}).addTo(mymap).bindPopup(name).openPopup();

		mymap.once("focus", function () {
			mymap.scrollWheelZoom.enable();
		});

		mymap.on("click", function () {
			if (mymap.scrollWheelZoom.enabled()) {
				mymap.scrollWheelZoom.disable();
			} else {
				mymap.scrollWheelZoom.enable();
			}
		});
	}

	// 1. ha van koordináta, azt használni
	if (hotelCoordsArray.length) {
		initialize(
			hotelCoordsArray[0],
			hotelCoordsArray[1],
			popupContent,
			initialZoom,
			"map"
		);
		// 2. ha nincs ,akkor nominatim és localStorage
	} else {
		if (localStorage.getItem(`resultData_${basedataId}`) === null) {
			$.get("https://nominatim.openstreetmap.org/search?q=" +
				fullAddress +
				"&format=json&limit=1"
			).then(
				function (result) {
					if (Object.keys(result).length) {
						localStorage.setItem(
							`resultData_${basedataId}`,
							JSON.stringify(result)
						);

						initialize(
							result[0].lat,
							result[0].lon,
							popupContent,
							initialZoom,
							"map"
						);
					} else {
						$("#map").hide();
					}
				},
				function () {
					console.log(result);
				}
			);
		} else {
			var result = JSON.parse(localStorage.getItem(`resultData_${basedataId}`));
			initialize(
				result[0].lat,
				result[0].lon,
				popupContent,
				initialZoom,
				"map"
			);
		}
	}
};

window.setRedirectSession = async function () {
	const myDropdown = document.getElementById("profile-dropdown");

	if (!myDropdown) {
		return;
	}
	myDropdown.addEventListener("show.bs.dropdown", async () => {
		try {
			const response = await fetch("/rendezvenyek/set-redirect-session", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-TOKEN": document.querySelector('meta[name="_token"]').getAttribute("content"),
					Accept: "application/json",
					"X-Requested-With": "XMLHttpRequest",
				},
			}).catch((err) => {
				console.error("Fetch failed 1:", err);
			});
		} catch (err) {
			console.error("Fetch failed 2:", err);
		}
	});
};

Rot13 = {
	map: null,
	convert: function (t) {
		Rot13.init();
		var r = "";
		for (i = 0; i < t.length; i++) {
			var n = t.charAt(i);
			r += (n >= "A" && n <= "Z") || (n >= "a" && n <= "z") ? Rot13.map[n] : n;
		}
		return r;
	},
	init: function () {
		if (null == Rot13.map) {
			var t = [],
				r = "abcdefghijklmnopqrstuvwxyz";
			for (i = 0; i < r.length; i++) t[r.charAt(i)] = r.charAt((i + 13) % 26);
			for (i = 0; i < r.length; i++)
				t[r.charAt(i).toUpperCase()] = r.charAt((i + 13) % 26).toUpperCase();
			Rot13.map = t;
		}
	},
	write: function (t) {
		document.write(Rot13.convert(t));
	},
};

/**
 * Selects and marks the last item in each group of a Choices.js dropdown.
 * It first removes any existing 'last-item' classes to avoid duplication,
 * then iterates through each group to find and mark the last item.
 * Magyarul, a choices listában a group utolsó listaeleme alatt nem lesz szürke csík
 */
window.selectChoicesLastItems = function () {
	const choicesGroups = document.querySelectorAll(".choices__list .choices__group");
	const onCorrectPage = choicesGroups.length;
	if (parseInt(onCorrectPage) == 0) {
		return;
	}
	// Először töröljük a régi jelöléseket, hogy ne duplikálódjon
	document.querySelectorAll(".choices__list .choices__item.last-item").forEach((el) => {
		el.classList.remove("last-item");
	});
	// Végigmegyünk minden group-on
	choicesGroups.forEach((group) => {
		let next = group.nextElementSibling;
		let lastItem = null;
		// Addig megyünk, amíg nem jön új group
		while (next && !next.classList.contains("choices__group")) {
			if (next.classList.contains("choices__item")) {
				lastItem = next;
			}
			next = next.nextElementSibling;
		}
		// Ha találtunk utolsó item-et, jelöljük
		if (lastItem) {
			lastItem.classList.add("last-item");
		}
	});
};
const choicesObserver = new MutationObserver((mutations) => {
	// Csak akkor futtatjuk, ha valóban változott a DOM
	let shouldRun = mutations.some(
		(m) => m.addedNodes.length || m.removedNodes.length
	);
	if (shouldRun) {
		selectChoicesLastItems();
	}
});

/**
 * Megjeleníti, vagy elrejti a beírt jelszót a jelszó mezőben
 * @param {string} fieldSelector a jelszó mező selectorja
 * @param {string} eyeIconSelector a szem ikon selectorja
 */
window.showHidePasswd = function name(fieldSelector) {
	const input = document.querySelector(fieldSelector + ' input[type="password"]');
	const eyeIcons = document.querySelectorAll(fieldSelector + ' [data-id="eye-icon"]');
	eyeIcons.forEach((eyeIcon) => {
		eyeIcon.addEventListener("click", function () {
			if (input.type === "password") {
				input.type = "text";
				eyeIcons[0].hidden = true;
				eyeIcons[1].hidden = false;
			} else {
				input.type = "password";
				eyeIcons[0].hidden = false;
				eyeIcons[1].hidden = true;
			}
		});
	});
};

window.getParticipantOpinionSlidesToShow = function () {
	return window.innerWidth >= 992 ? 3 : 1;
};

window.equalizeParticipantOpinionHeights = function ($carousel) {
	const slidesToShow = window.getParticipantOpinionSlidesToShow();
	const carouselWidth = $carousel.innerWidth();

	if (!carouselWidth) {
		return;
	}

	const slideWidth = Math.floor(carouselWidth / slidesToShow);
	const isInitialized = $carousel.hasClass("slick-initialized");
	const $sourceSlides = isInitialized
		? $carousel.find(".slick-slide:not(.slick-cloned) .participant-opinion-slide")
		: $carousel.children(".participant-opinion-slide");

	if (!$sourceSlides.length) {
		return;
	}

	const $allCards = $carousel.find(".rounded-outline");
	$allCards.css("height", "auto");

	const savedStyles = [];
	let maxHeight = 0;

	$sourceSlides.each(function (index) {
		const $slide = $(this);
		const $card = $slide.find(".rounded-outline").first();

		if (!isInitialized) {
			savedStyles[index] = {
				width: $slide[0].style.width,
				float: $slide[0].style.float,
			};

			$slide.css({
				width: `${slideWidth}px`,
				float: "left",
			});
		}

		maxHeight = Math.max(maxHeight, $card.outerHeight());
	});

	if (!isInitialized) {
		$sourceSlides.each(function (index) {
			$(this).css(savedStyles[index]);
		});
	}

	if (maxHeight > 0) {
		$allCards.css("height", `${maxHeight}px`);

		if (isInitialized) {
			$carousel.find(".slick-list, .slick-track").css("height", `${maxHeight}px`);
		}
	}
};

window.initParticipantOpinionsCarousel = function () {
	$(".participant-opinions-carousel").each(function () {
		const $carousel = $(this);

		if (!$carousel.children().length) {
			return;
		}

		if ($carousel.hasClass("slick-initialized")) {
			$carousel.off("setPosition");
			$carousel.slick("unslick");
		}

		window.equalizeParticipantOpinionHeights($carousel);

		$carousel.slick({
			autoplay: true,
			autoplaySpeed: 10000,
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			pauseOnHover: true,
			pauseOnFocus: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

		window.requestAnimationFrame(() => {
			window.equalizeParticipantOpinionHeights($carousel);
		});
	});
};

document.addEventListener("DOMContentLoaded", () => {
	const target = document.querySelector("main") || document.body;
	choicesObserver.observe(target, { childList: true, subtree: true });
	siteMenuHandler();
	displayStatNumbers();
	clickableCards();
	cardAnimation();
	setMobileProgramMenuText();
	daySelector();
	handleSearchClear();
	setRedirectSession();
	setSecondaryMenuVisibility();
	initParticipantOpinionsCarousel();
});

window.addEventListener("scroll", () => {
	setHeaderShadow();
});

let participantOpinionsResizeTimer;

window.addEventListener("resize", () => {
	setTimeout(() => {
		window.placeTimeBadges();
	}, 100);
	window.resizeSpeakerCards();

	clearTimeout(participantOpinionsResizeTimer);
	participantOpinionsResizeTimer = setTimeout(() => {
		if ($(".participant-opinions-carousel").length) {
			window.initParticipantOpinionsCarousel();
		}
	}, 200);
});

window.onclick = function (event) {
	window.closeMobileConferenceMenu(event);
};
